import type { SkillMeasurement } from '@/api/placement'

type Translate = (key: string, options?: Record<string, unknown>) => string

/**
 * Подпись навыка, у которого нет измеренного уровня.
 *
 * Одна на все экраны намеренно. Раньше карточка профиля, экран результата и
 * список тестов подписывали один и тот же навык по-разному — «не измеряли»
 * против «пока не проверяем», — и человек на одной странице читал два ответа
 * про одно.
 *
 * Исходов четыре, и путать их нельзя:
 *  - точный уровень — поиск сомкнулся;
 *  - граница («не выше B2») — тест прервали, и это не то же самое, что провал;
 *  - «пока не проверяем» — заданий навыка в банке нет, мерить было нечем;
 *  - «ждёт проверки» — проба письма или речи, балл которой ставит человек.
 */
export function skillMeasurementLabel(
  measurement: SkillMeasurement | undefined,
  t: Translate,
  options: { isProbe?: boolean } = {},
): string {
  if (measurement?.state === 'measured' && measurement.level !== null) {
    return measurement.level
  }

  if (measurement?.state === 'not_testable') {
    return t('placement.notTestable')
  }

  if (measurement?.state === 'bounded') {
    if (measurement.floor !== null && measurement.ceiling !== null) {
      return t('placement.between', { from: measurement.floor, to: measurement.ceiling })
    }

    if (measurement.floor !== null) {
      return t('placement.atLeast', { level: measurement.floor })
    }

    if (measurement.ceiling !== null) {
      return t('placement.atMost', { level: measurement.ceiling })
    }
  }

  return options.isProbe ? t('placement.underReview') : t('placement.notMeasured')
}

/** Пробы: автопроверки у них нет, уровень ставит человек. */
export const PROBE_SKILLS: string[] = ['writing', 'speaking']
